export default "__VITE_ASSET__CJ1Lnkhj__"